export default __webpack_public_path__ + "static/media/404.e8ea0db5.svg";